import { render, staticRenderFns } from "./SeriesCardList.vue?vue&type=template&id=b87392a0&"
import script from "./SeriesCardList.vue?vue&type=script&lang=js&"
export * from "./SeriesCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports